import CryptoJS from 'crypto-js';

/**
 * Función para encriptar datos
 * @param {Object} data Datos a encriptar
 * @returns {String} Retorna datos encriptados
 */
function encriptar(data) {
  if (!data) return '';
  try {
    const str = typeof data === 'string' ? data : JSON.stringify(data);
    return encodeURIComponent(CryptoJS.AES.encrypt(str, process.env.REACT_APP_SECRET_KEY).toString());
  } catch (e) {
    return '';
  }
}

/**
 * Función para desencriptar datos
 * @param {String} data Datos a desencriptar
 * @returns {Object|Array|String|null} Retorna datos desencriptados
 */
function desencriptar(data) {
  if (!data) return null;
  if (typeof data !== 'string') return data;
  try {
    const decryptedData = CryptoJS.AES.decrypt(decodeURIComponent(data), process.env.REACT_APP_SECRET_KEY);
    const utf8Str = decryptedData.toString(CryptoJS.enc.Utf8);
    if (!utf8Str) return data;
    try {
      return JSON.parse(utf8Str);
    } catch (jsonErr) {
      return utf8Str;
    }
  } catch (error) {
    return data;
  }
}

export { encriptar, desencriptar };